import { render, staticRenderFns } from "./Historial.vue?vue&type=template&id=18dadc49&scoped=true&lang=pug&"
import script from "./Historial.vue?vue&type=script&lang=js&"
export * from "./Historial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dadc49",
  null
  
)

export default component.exports